const ProjectCreate = () => import("@/components/Admin/Project/ProjectCreate");
const ProjectEdit = () => import("@/components/Admin/Project/ProjectEdit");
const ProjectIndex = () => import("@/components/Admin/Project/ProjectIndex");
const ProjectView = () => import("@/components/Admin/Project/ProjectView");

const routes = [
  {
    name: "ProjectIndex",
    path: "/projects",
    component: ProjectIndex,
    meta: {
      title: "Projects",
      sidebar: true
    }
  },
  {
    name: "ProjectCreate",
    path: "/projects/create",
    component: ProjectCreate,
    meta: {
      title: "Create project",
      sidebar: true
    }
  },
  {
    name: "ProjectView",
    path: "/projects/:id",
    component: ProjectView,
    meta: {
      title: "View project",
      sidebar: true
    }
  },
  {
    name: "ProjectEdit",
    path: "/projects/:id/edit",
    component: ProjectEdit,
    meta: {
      title: "Edit project",
      sidebar: true
    }
  }
];

export default routes;
